/**
 * core-api 前缀：local 用相对路径 /core-api（webpack 代理到本机 8093）；
 * online 用 CORE_API_ORIGIN 直连远程，如 https://fullagent.hao-xiansheng.com/core-api
 */
export default function coreApiRoot () {
  const origin = (process.env.CORE_API_ORIGIN || "").replace(/\/$/, "")
  return origin ? `${origin}/core-api` : "/core-api"
}



// WEBPACK FOOTER //
// ./src/utils/coreApiRoot.js